import { render, staticRenderFns } from "./ControlYear.vue?vue&type=template&id=22abf6dd&scoped=true&lang=pug&"
import script from "./ControlYear.vue?vue&type=script&lang=js&"
export * from "./ControlYear.vue?vue&type=script&lang=js&"
import style0 from "./ControlYear.vue?vue&type=style&index=0&id=22abf6dd&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22abf6dd",
  null
  
)

export default component.exports